// extracted by mini-css-extract-plugin
export default {"container":"YA-z","brandName":"ZA-z","productName":"_A-z","aboveGalleryInfo":"aB-z","belowGalleryInfo":"bB-z","breakLongProductName":"cB-z"};